module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "illustration"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle1"
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "illus_p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part1#part1"
    }
  }, [_c('i', [_vm._v("The Morning of the Monkey")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#UF1-1"
    }
  }, [_vm._v("Judge Dee saw that the gibbon was watching him")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#UF1-2"
    }
  }, [_vm._v("‘I am not yet through with you, Mr Leng!’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#UF1-3"
    }
  }, [_vm._v("‘It's a very private matter,’ Tao Gan said")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#UF1-4"
    }
  }, [_vm._v("‘Well,’ she said, ‘I have done nothing wrong’")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent",
    attrs: {
      "id": "illus_p6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "illus_p7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Night of the Tiger")])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#UF2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judge Dee caught the spear on his sword")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#UF2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He pulled the silk strings in succession")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#UF2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suddenly the judge had the feeling that he was not alone")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#UF2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘I grabbed her and shouted at her to stop…’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "illus_p14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#UF2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A sketchmap of the flooded area")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18041542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustration.vue
// module id = 69
// module chunks = 0